export default __webpack_public_path__ + "images/0x5300000000000000000000000000000000000004.png";